var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.params.data && _vm.params.data.campaign_version === 'v3')?_c('router-link',{staticClass:"review-buttons",attrs:{"id":"system-campaigns-ads-list-table-review-button","to":{
      name: 'campaigns-edit',
      params: {
        id: _vm.params.data.campaign_id
      },
      query: {
        step: 3
      }
    }}},[_vm._v("\n  Review\n  ")]):_c('span',{staticClass:"review-buttons cursor-not-allowed text-gray-400"},[_vm._v("\n    Campaign Archived\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }